import { render, staticRenderFns } from "./ContactSales.vue?vue&type=template&id=88571ce8"
import script from "./ContactSales.vue?vue&type=script&lang=js"
export * from "./ContactSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports